import config from 'config';
import { format } from 'date-fns';
import { NotificationPayloadOutput } from 'gql/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  payload: NotificationPayloadOutput;
};

const AppointmentForGroupCreated: FC<PropTypes> = ({ payload }) => {
  const { t } = useTranslation(
    'notification.NotificationCard.AppointmentForGroupCreated'
  );
  const appointment = payload?.appointment;
  if (!appointment) {
    return null;
  }
  const appointmentMembers = appointment.users
    .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
    .join(', ');
  const content = t('appointmentJustCreated', {
    appointmentMembers,
    appointmentTitle: appointment.title,
    start: format(
      new Date(appointment.start),
      config.DATE_FORMATS.LOCALIZED_TIME
    ),
    end: format(new Date(appointment.end), config.DATE_FORMATS.LOCALIZED_TIME),
    groupTitle: appointment.group?.title,
    context: appointment.group ? 'withGroup' : undefined,
  });
  return <>{content}</>;
};

export default AppointmentForGroupCreated;
